import { render, staticRenderFns } from "./DashboardFornecedor.vue?vue&type=template&id=6f162292&"
import script from "./DashboardFornecedor.vue?vue&type=script&lang=js&"
export * from "./DashboardFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports